import { render, staticRenderFns } from "./closeAcct.vue?vue&type=template&id=7ed440ca&scoped=true"
import script from "./closeAcct.vue?vue&type=script&lang=js"
export * from "./closeAcct.vue?vue&type=script&lang=js"
import style0 from "./closeAcct.vue?vue&type=style&index=0&id=7ed440ca&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ed440ca",
  null
  
)

export default component.exports